module.exports = __webpack_public_path__ + "static/media/1008154.c90e1257.png";